import { defineStore } from 'pinia';

export const useReportStore = defineStore('report-store', {
  state: () => ({
    reportBiomarkers: ['BMORE', 'BMOREMax'],
    selectedBiomarker: 'BMORE',
    report: {
      reportTitle: 'BE-OS CMR Report',
      reportLogo: {
        url: null,
        img: null,
        ratio: null,
      },

      patientName: 'CLIENT ID',
      patientGender: '',
      patientAge: '00',
      patientDOB: '',
      patientID: '',

      rbhNumber: '000 000 000',
      protocol: 'OS-CMR',
      scanDate: '',
      scanTime: '00:00',
      reportDate: '',

      completeData: '',
      imageQuality: '',

      reader: '',
      verifier: '',

      readers: [],

      scannerSystem: 'Philips Ingenia',
      fieldStrength: '1.5T',
      softwareVersion: '5.7.1.3',
      starClaimer:
        '*Normal values are continuously being updated, therefore, may be subject to changes',

      summary: '',

      heartRateBaseline: '00',
      // heartRateBaselineNormalRange: "55-85", 00
      heartRateHV: '00',
      heartRateBH: '00',
      // heartRateBHNormalRange: "55-85",
      dtheartrate: '00',
      // dtheartrateNormalRange: ">15",

      vascularGlobal: '00',
      vascularLAD: '00',
      vascularLCX: '00',
      vascularRCA: '00',
      normalRangeVascular: '>7.0',

      strainLADBaseline: '00',
      strainLADHV: '00',
      strainLADBH: '00',

      strainLCXBaseline: '00',
      strainLCXHV: '00',
      strainLCXBH: '00',

      strainRCABaseline: '00',
      strainRCAHV: '00',
      strainRCABH: '00',

      strainGLOBALBaseline: '00',
      strainGLOBALHV: '00',
      strainGLOBALBH: '00',

      vasocapacitySlice1: { img: null, x: 0, y: 0, zoom: 1, final: null },
      vasocapacitySlice2: { img: null, x: 0, y: 0, zoom: 1, final: null },
      vasoconstrictionSlice1: { img: null, x: 0, y: 0, zoom: 1, final: null },
      vasoconstrictionSlice2: { img: null, x: 0, y: 0, zoom: 1, final: null },

      extraNumbers: [],
      oxygenSensitiveMap: '',
      AHA1: '',
      AHA2: '',
      AHA3: '',
      AHA4: '',
      AHA5: '',
      AHA6: '',
      AHA7: '',
      AHA8: '',
      AHA9: '',
      AHA10: '',
      AHA11: '',
      AHA12: '',

      strainMapImage: '',

      coronaryTerritoryLAD: 'NaN',
      coronaryTerritoryLCX: 'NaN',
      coronaryTerritoryRCA: 'NaN',

      strainMapBaseline: '',
      strainMapHV: '',
      strainMapBH: '',
      normalRange: '<-20%',
    },
    signalIntensity: [
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [0, 114, 189],
      [6, 115, 185],
      [11, 117, 182],
      [17, 118, 178],
      [22, 120, 174],
      [28, 121, 171],
      [33, 123, 167],
      [39, 124, 163],
      [44, 126, 160],
      [50, 127, 156],
      [55, 129, 152],
      [61, 130, 149],
      [66, 132, 145],
      [72, 133, 142],
      [77, 135, 138],
      [83, 136, 134],
      [88, 137, 131],
      [94, 139, 127],
      [99, 140, 123],
      [105, 142, 120],
      [110, 143, 116],
      [116, 145, 112],
      [121, 146, 109],
      [127, 148, 105],
      [132, 149, 101],
      [138, 151, 98],
      [143, 152, 94],
      [149, 154, 90],
      [154, 155, 87],
      [160, 156, 83],
      [165, 158, 79],
      [171, 159, 76],
      [176, 161, 72],
      [182, 162, 69],
      [187, 164, 65],
      [193, 165, 61],
      [198, 167, 58],
      [204, 168, 54],
      [209, 170, 50],
      [215, 171, 47],
      [220, 173, 43],
      [226, 174, 39],
      [231, 176, 36],
      [237, 177, 32],
      [237, 173, 31],
      [238, 169, 31],
      [238, 165, 30],
      [239, 161, 29],
      [239, 156, 28],
      [240, 152, 28],
      [240, 148, 27],
      [240, 144, 26],
      [241, 140, 25],
      [241, 136, 25],
      [242, 132, 24],
      [242, 128, 23],
      [242, 123, 22],
      [243, 119, 22],
      [243, 115, 21],
      [244, 111, 20],
      [244, 107, 19],
      [245, 103, 19],
      [245, 99, 18],
      [245, 95, 17],
      [246, 91, 16],
      [246, 86, 16],
      [247, 82, 15],
      [247, 78, 14],
      [247, 74, 13],
      [248, 70, 13],
      [248, 66, 12],
      [249, 62, 11],
      [249, 58, 10],
      [250, 54, 10],
      [250, 49, 9],
      [250, 45, 8],
      [251, 41, 7],
      [251, 37, 7],
      [252, 33, 6],
      [252, 29, 5],
      [252, 25, 4],
      [253, 21, 4],
      [253, 16, 3],
      [254, 12, 2],
      [254, 8, 1],
      [255, 4, 1],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
      [255, 0, 0],
    ],
  }),
  getters: {
    reportData() {
      return this.report;
    },
    //
  },
  actions: {
    updateReport(newReport) {
      const oldReport = this.report;
      // Iterate through each key in the newReport object

      for (const key in newReport) {
        if (typeof newReport[key] === 'object') {
          if (!oldReport[key]) {
            oldReport[key] = {};
          }

          for (const subKey in newReport[key]) {
            oldReport[key][subKey] = newReport[key][subKey];
          }
        }
        else {
          oldReport[key] = newReport[key];
        }
      }
      // console.log("done");
    },
    calculateAge() {
      // Check internal DOB:
      const birthDate = this.report.patientDOB;
      if (!birthDate) return;

      let targetDate = this.report.scanDate;
      if (!targetDate) {
        targetDate = new Date();
      }
      else {
        targetDate = new Date(targetDate);
      }

      const birth = new Date(birthDate);

      let age = targetDate.getFullYear() - birth.getFullYear();
      const m = targetDate.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && targetDate.getDate() < birth.getDate())) {
        age--;
      }
      this.report.patientAge = age.toString();
    },

    dicomDateToDisplay(dicomDate) {
      if (
        !dicomDate
        || typeof dicomDate !== 'string'
        || dicomDate.length !== 8
        || !/^\d{8}$/.test(dicomDate)
      ) {
        return '';
      }
      const monthNames = [
        'JAN',
        'FEB',
        'MAR',
        'APR',
        'MAY',
        'JUN',
        'JUL',
        'AUG',
        'SEP',
        'OCT',
        'NOV',
        'DEC',
      ];
      const year = Number.parseInt(dicomDate.substring(0, 4), 10);
      const month = Number.parseInt(dicomDate.substring(4, 6), 10) - 1; // Months are 0-based
      const day = Number.parseInt(dicomDate.substring(6, 8), 10);
      const date = new Date(year, month, day);
      if (Number.isNaN(date.getTime())) return '';
      const formattedDay = String(date.getDate()).padStart(2, '0');
      const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
      const formattedYear = date.getFullYear();
      const monthName = monthNames[Number.parseInt(formattedMonth, 10)];

      return `${formattedDay}-${monthName}-${formattedYear}`;
    },
    //
  },
});
